import type { ReactNode } from 'react';

import { Button } from './Button';
import { Spinner } from './Spinner';

type StateBlockProps = {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  details?: string;
  action?: ReactNode;
};

export function StateBlock({ icon, title, description, details, action }: StateBlockProps) {
  return (
    <div className="state-block">
      {icon !== undefined ? (
        <div className="state-block__icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}
      <p className="state-block__title">{title}</p>
      {description !== undefined ? <p className="state-block__description">{description}</p> : null}
      {details !== undefined && details !== '' ? (
        <p className="state-block__details">{details}</p>
      ) : null}
      {action !== undefined ? <div className="state-block__actions">{action}</div> : null}
    </div>
  );
}

export function LoadingState({ title = 'Загружаем данные' }: { title?: string }) {
  return (
    <div className="state-block">
      <Spinner size="lg" label={title} />
      <p className="state-block__title">{title}</p>
      <p className="state-block__description">Это займёт несколько секунд.</p>
    </div>
  );
}

type ErrorStateProps = {
  title?: string;
  description?: string;
  details?: string;
  onRetry?: () => void;
};

export function ErrorState({
  title = 'Не удалось загрузить данные',
  description = 'Проверьте соединение с сервисом и попробуйте снова. Если ошибка повторяется, обратитесь к администратору.',
  details,
  onRetry,
}: ErrorStateProps) {
  return (
    <div role="alert">
      <StateBlock
        icon="!"
        title={title}
        description={description}
        {...(details !== undefined ? { details } : {})}
        {...(onRetry !== undefined
          ? {
              action: (
                <Button variant="secondary" onClick={onRetry}>
                  Повторить
                </Button>
              ),
            }
          : {})}
      />
    </div>
  );
}
